// extracted by mini-css-extract-plugin
export var numpadContainer = "_sl-1";
export var phoneButton = "_sl-0";